import * as z from "zod";
import type {
  PortalSettingsPatch,
  ReturnsPortalSettingsSource,
} from "./portal-settings-source";

export const brandingSettingsShape = {
  branding: z.object({ showPortalBranding: z.boolean() }),
};

type BrandingSettings = z.infer<z.ZodObject<typeof brandingSettingsShape>>;

export function brandingSettingsFromTeam({
  settings,
}: ReturnsPortalSettingsSource): BrandingSettings {
  return { branding: { showPortalBranding: !settings.hidePortalBranding } };
}

export function brandingTeamPatch({
  branding,
}: BrandingSettings): PortalSettingsPatch {
  return {
    set: { hidePortalBranding: !branding.showPortalBranding },
    unset: [],
  };
}
